import { ASharedModal, SharedModalTitle } from 'views/components/SharedModal'
import { EditFields, FarmerLoadCommonContent } from './ModalCommonContent'
import { useFormik } from 'formik'
import { useAFormHandler } from 'analytics/hooks'
import { useTranslation } from 'react-i18next'
import { apiClient } from 'modules/utils/httpClient'
import { FarmerLoad, ShipLoad } from 'modules/domain/deal/types'
import { endpoints } from 'modules/endpoints'
import { useParams } from 'react-router-dom'
import { refetchFunc } from 'modules/domain/common/hooks'
import { FC } from 'react'

type Props = {
  onClose: () => void
  loadItem: ShipLoad | FarmerLoad
  refetch: refetchFunc
}

export const EditFarmerLoadModal: FC<Props> = ({ onClose, loadItem, refetch }) => {
  const { id: dealId } = useParams()
  const { t } = useTranslation('deal')
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<EditFields>({
    initialValues: {
      id: parseInt(loadItem.id), // this field is required to choose multiple or single dropdown
      regional: loadItem.regional.id,
      work_type: loadItem.work_type,
      load_date: loadItem.load_date,
      quantity: loadItem.quantity,
    },

    onSubmit: formHandler(() => apiClient.put(endpoints.dealSingleFarmerLoading(dealId, loadItem.id), formik.values), {
      onSuccess: async () => {
        await refetch(true)
        onClose()
      },
      onError: (error) => {
        const { errors } = error
        formik.setErrors(errors)
      },
    }),
  })

  return (
    <ASharedModal id="farmerLoad" onClose={onClose}>
      <SharedModalTitle>{t('accordion.loading.edit_farmer_load')}</SharedModalTitle>
      <FarmerLoadCommonContent formik={formik} progress={formProgress} onClose={onClose} />
    </ASharedModal>
  )
}
